import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { ChangeEvent, ReactNode } from "react";
import { CloseIcon } from "../images";

type Props = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  prefixIcon?: ReactNode;
  postfixIcon?: ReactNode;
  clearButton?: boolean;
  minHeight?: string;
  isDisabled?: boolean;
};

export const CustomInput = ({
  value,
  placeholder,
  onChange,
  prefixIcon,
  postfixIcon,
  clearButton,
  minHeight,
  isDisabled,
}: Props) => {
  return (
    <TextField
      disabled={isDisabled}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          minHeight,
          "& fieldset": {
            borderColor: "#CFCFCF",
          },
          "&:hover": {
            borderColor: "#CFCFCF",
          },
          "&.Mui-focused": {
            borderColor: "#CFCFCF",
          },
        },
      }}
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      placeholder={placeholder}
      slotProps={{
        input: {
          startAdornment: prefixIcon && (
            <Box display="flex" alignItems="center" justifyContent="center">
              {prefixIcon}
            </Box>
          ),
          endAdornment:
            postfixIcon ||
            (clearButton && (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                paddingRight="4px"
              >
                {postfixIcon
                  ? postfixIcon
                  : clearButton && (
                      <IconButton
                        sx={{
                          height: "32px",
                          width: "32px",
                          visibility: value ? "visible" : "hidden",
                        }}
                        onClick={() => onChange("")}
                      >
                        <CloseIcon
                          color="currentColor"
                          width="24px"
                          height="24px"
                        />
                      </IconButton>
                    )}
              </Box>
            )),
        },
      }}
    />
  );
};
